module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-prev-6d0bf2ea4215fefe67eaf9ae586f3beb.svg";